<template>
  <section class="settingFrom_wrapper">
    <div class="settingFrom_header">
      <h1>{{ $store.getters["event/event"].name }}</h1>
    </div>
    <div class="settingFrom_inner notice">
      <div class="inner_title">
        注意事項
      </div>
      <div class="inner_content">
        <p v-if="auth.type === 1">
          ヨシダ社員は、会場の開催期間にかかわらず公開されていれば会場に入ることができます。メッセージやチャットは後日見ることができますが、他の人のメッセージなど自分が見れないメッセージはプライバシー上確認できません。
          <br />またメッセージはイベント終了後（いまのところ１ヶ月程度を目途）に削除を予定しています。必要な情報は各自お手元にコピーしておいてください。
        </p>
        <p v-else>
          イベントが終了後はメッセージやチャットなどの記録は確認できなくなります。部屋ごとのメッセージは会議室のホワイトボード同様に参加者ご自身で消してもらうことになります。
          <br />必要な情報はお手元にコピーをお願いします。情報管理の観点からお問い合わせがあっても対応できない内容になっておりますのでご了承ください。
        </p>
      </div>
    </div>
    <validation-observer ref="observer" v-slot="{handleSubmit, invalid}" class="form_body">
      <form @submit.prevent="handleSubmit(updateSetting)">
        <div class="settingFrom_inner notice">
          <div class="inner_title">
            プロフィール設定
          </div>
          <div class="inner_content">
            <div v-if="$store.getters['auth/isGuest']" class="text_input">
              <validation-provider rules="required|max:255" v-slot="{errors}" name="医院名等" tag="div" class="form-group">
                <label for="organization_name">医院名等</label>
                <input type="text" id="organization_name" name="organization_name" placeholder="医院名等" v-model="settingForm.organization_name" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" class="error" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </validation-provider>
              <validation-provider rules="required|max:255" v-slot="{errors}" name="氏名" tag="div" class="form-group">
                <label for="name">氏名</label>
                <input type="text" id="name" name="name" placeholder="氏名" v-model="settingForm.name" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" class="error" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </validation-provider>
            </div>

            <div class="tab_box">
              <div class="tabs">
                <input type="radio" :value="'icons'" id="imageableType_icon" v-model="imageable_type" name="imageable_type" />
                <label for="imageableType_icon">アイコン選択</label>
                <input type="radio" :value="'files'" id="imageableType_file" v-model="imageable_type" name="imageable_type" />
                <label for="imageableType_file">カスタムアイコン</label>
              </div>
              <ul class="tab_contents">
                <li v-show="imageable_type === 'icons'">
                  <div class="radio_input">
                    <validation-provider v-slot="{errors}" ref="imageable_id" name="アイコン" tag="div" class="form-group">
                      <ul v-if="errors.length">
                        <li v-for="(error, key) in errors" :key="key" class="error" style="color: #ff0000;">{{ error }}</li>
                      </ul>
                      <div class="icon_list">
                        <div class="icon_item" v-for="icon in icons" :key="icon.id">
                          <label :for="'icon_' + icon.id">
                            <img :src="icon.url" :class="{isChecked: settingForm.imageable_id === icon.id}" />
                            <input
                              :id="'icon_' + icon.id"
                              type="radio"
                              :value="icon.id"
                              name="imageable_id"
                              v-model="settingForm.imageable_id"
                              @change="changeIcon"
                            />
                          </label>
                        </div>
                      </div>
                    </validation-provider>
                  </div>
                </li>
                <li v-show="imageable_type === 'files'">
                  <div class="radio_input">
                    <validation-provider v-slot="{errors}" ref="icon" name="カスタムアイコン" tag="div" class="form-group custom_icon" vid="icon">
                      <ul v-if="errors.length">
                        <li v-for="(error, key) in errors" :key="key" class="error" style="color: #ff0000;">{{ error }}</li>
                      </ul>
                      <div class="custom_icon_img">
                        <croppa
                          v-model="croppa"
                          @file-choose="
                            unsetIcons()
                            changeIcon($event)
                          "
                          @image-remove="unsetCustomIcon"
                        >
                          <img crossOrigin="anonymous" v-if="auth.has_icon_file" slot="placeholder" :src="auth.icon_url" />
                          <div class="spinner" v-if="croppa && croppa.loading" />
                        </croppa>
                        <div class="option_btns">
                          <button type="button" @click="croppa.rotate(-1)">
                            <fa-icon icon="undo" :style="{transform: 'rotate(' + '-120deg)'}" />
                          </button>
                          <button type="button" @click="croppa.flipX()"><fa-icon icon="exchange-alt" /></button>
                          <button type="button" @click="croppa.flipY()">
                            <fa-icon icon="exchange-alt" :style="{transform: 'rotate(' + '90deg)'}" />
                          </button>
                          <button type="button" @click="croppa.rotate()">
                            <fa-icon icon="redo-alt" :style="{transform: 'rotate(' + '120deg)'}" />
                          </button>
                        </div>
                      </div>
                      <small>※ 拡大縮小: ピンチイン・アウト, マウススクロール</small>
                    </validation-provider>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="settingFrom_footer">
          <button class="btn" type="submit" :disabled="invalid">
            <span v-if="$store.getters['auth/hasSetting']">更新</span>
            <span v-else>入室</span>
          </button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>

<script>
export default {
  name: "Setting",
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icons: [],
      settingForm: {
        _method: "PUT",
        organization_name: "",
        name: "",
        imageable_id: null,
        icon: null
      },
      imageable_type: null,
      croppa: {}
    }
  },
  computed: {
    auth() {
      return this.$store.getters["auth/user"]
    }
  },
  created() {
    this.getIcons()
    this.setUserInfo()
  },
  methods: {
    getIcons() {
      this.$axios.get("icons").then(response => {
        this.icons = response.data.icons
      })
    },
    setUserInfo() {
      this.settingForm.name = this.auth.name
      this.settingForm.organization_name = this.auth.organization
      this.imageable_type = this.auth.icon_type || "icons"
      if (this.auth.has_icon_id) {
        this.settingForm.imageable_id = this.auth.icon_id
      }
    },
    async updateSetting() {
      this.$store.commit("loading/setLoading", true)
      console.log("auth update")

      const file = this.croppa.$data.chosenFile
      if (file) {
        this.settingForm.icon = await this.croppa.promisedBlob(file.type, 0.8)
      }

      const formData = new FormData()
      _.forEach(this.settingForm, function(value, key) {
        if (!value) return

        if (key === "icon") {
          file ? formData.append(key, value, file.name) : formData.append(key, value)
        } else {
          formData.append(key, value)
        }
      })

      await this.$store.dispatch("auth/update", {
        endpoint: `auth/${this.slug}/update`,
        inputs: formData,
        validationObserver: this.$refs.observer,
        slug: this.slug
      })
    },
    unsetIcons() {
      this.settingForm.imageable_id = null
      this.settingForm.icon = null
    },
    unsetCustomIcon() {
      this.settingForm.icon = null
    },
    changeIcon(e) {
      if (e instanceof Event && e.target.name === "imageable_id" && this.croppa.hasImage()) {
        this.croppa.remove()
      }

      this.resetError(e)
    },
    resetError(e) {
      if (e instanceof Event && e.target.name === "imageable_id") {
        this.$refs.icon.reset()
      } else if (e instanceof File) {
        this.$refs.imageable_id.reset()
        this.$refs.icon.reset()
      }
    },
    removeCurrentImage() {
      this.croppa.remove()
    }
  }
}
</script>

<style scoped></style>
